import store from '@store';
import { replaceCart, addChecks, updateSeatInfo, setUpdatingCartStatus } from '@reducers/orders';
import { setErrorPopUp } from '@reducers/notification';

export const addInProcessItemsToCart = (cb = () => {}, cart = []) => {
  const { oauth, orders } = store.getState();
  const currentCart = cart ?? orders.cart;
  const inProcessItem = currentCart?.filter(e => e.isProcessing);
  store.dispatch(setUpdatingCartStatus(true));

  const dataToSendToAdd = {
    storeId: oauth?.deviceInformation?.storeId,
    deviceId: oauth?.deviceInformation?.deviceId,
    employeeId: Number(oauth?.loggedInUserData?.id),
    employeeCard: oauth?.loggedInUserData?.employeeCard,
    checkHeaderId: orders?.seats?.id,
    stationId: orders?.seats?.stationId,
    items: inProcessItem,
    orderJson: JSON.stringify([...inProcessItem]),
    longitude: '0',
    latitude: '0',
    geoLocation: '0',
  };

  if (inProcessItem?.length > 0) {
    store
      .dispatch(addChecks(dataToSendToAdd, 'add', false))
      .then(res => {
        store.dispatch(updateSeatInfo(res));
        const ItemsArray = res.orders[0]?.items || [];
        if (ItemsArray?.length > 0) {
          const CartItems = [];
          ItemsArray.forEach(item => {
            if (item.pending && item.itemType !== 'D') {
              const cartData = {
                ...JSON.parse(JSON.parse(item?.orderJson)?.modifierJson),
                isProcessing: false,
                modifierJson: JSON.parse(item?.orderJson)?.modifierJson,
                id: item.id,
                checkItemId: item.checkItemId,
              };
              CartItems.push(cartData);
            }
          });
          store.dispatch(replaceCart(CartItems));
          store.dispatch(setUpdatingCartStatus(false));
          const filteredCart = getFilteredOutModifiersFromParentItem(CartItems);
          if (cb) {
            cb(filteredCart, res);
          }
        }
      })
      .catch(err => {
        store.dispatch(setUpdatingCartStatus(false));
        store.dispatch(
          setErrorPopUp({
            res: err.message,
          })
        );
      });
  } else {
    store.dispatch(setUpdatingCartStatus(false));
    const filteredCart = getFilteredOutModifiersFromParentItem(currentCart);
    if (cb) {
      cb(filteredCart, orders.seats);
    }
  }
};

export const addInProcessItemsToCartAsync = (cart = []) => {
  return new Promise((resolve, reject) => {
    const { oauth, orders } = store.getState();
    const currentCart = cart ?? orders.cart;
    const inProcessItem = currentCart?.filter(e => e.isProcessing);

    if (!inProcessItem || inProcessItem.length === 0) {
      resolve({ needsApi: false, filteredCart: getFilteredOutModifiersFromParentItem(currentCart) });
      return;
    }

    const dataToSendToAdd = {
      storeId: oauth?.deviceInformation?.storeId,
      deviceId: oauth?.deviceInformation?.deviceId,
      employeeId: Number(oauth?.loggedInUserData?.id),
      employeeCard: oauth?.loggedInUserData?.employeeCard,
      checkHeaderId: orders?.seats?.id,
      stationId: orders?.seats?.stationId,
      items: inProcessItem,
      orderJson: JSON.stringify([...inProcessItem]),
      longitude: '0',
      latitude: '0',
      geoLocation: '0',
    };

    store
      .dispatch(addChecks(dataToSendToAdd, 'add', false))
      .then(res => {
        store.dispatch(updateSeatInfo(res));
        const ItemsArray = res.orders[0]?.items || [];
        const CartItems = [];
        if (ItemsArray.length > 0) {
          ItemsArray.forEach(item => {
            if (item.pending && item.itemType !== 'D') {
              const cartData = {
                ...JSON.parse(JSON.parse(item?.orderJson)?.modifierJson),
                isProcessing: false,
                modifierJson: JSON.parse(item?.orderJson)?.modifierJson,
                id: item.id,
                checkItemId: item.checkItemId,
              };
              CartItems.push(cartData);
            }
          });
          store.dispatch(replaceCart(CartItems));
        }
        resolve({ needsApi: true, filteredCart: getFilteredOutModifiersFromParentItem(CartItems) });
      })
      .catch(err => {
        reject(err);
      });
  });
};

// Helpers

const getFilteredOutModifiersFromParentItem = (CartItems = []) => {
  return CartItems.reduce((a, v) => {
    const obj = { ...v };
    if (v.hasLinkedMenuItem && Array.isArray(obj.modifiers)) {
      obj.modifiers = obj.modifiers.filter(m => !m.isLinkedItem);
    }
    a.push(obj);
    return a;
  }, []);
};
